import { render, staticRenderFns } from "./IconGlobe.vue?vue&type=template&id=4219d2a0&"
import script from "./IconGlobe.vue?vue&type=script&lang=ts&"
export * from "./IconGlobe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports